<template>
    <div :class="[$store.state.layout_style, $store.state.menu_style]">
        <component v-if="layout" v-bind:is="layout"></component>

        <BackToTop />
    </div>
</template>
<script setup>
    import { computed } from 'vue';
    import '@/assets/sass/app.scss';
    import { useMeta } from '@/composables/use-meta';
    import { useStore } from 'vuex';
    import BackToTop from './components/layout/BackToTop.vue';

    useMeta({ title: 'Lance Fácil' });

    const store = useStore();

    const layout = computed(() => {
        return store.getters.layout;
    });


</script>
<script>
    // layouts
    import appLayout from './layouts/app-layout.vue';
    import authLayout from './layouts/auth-layout.vue';
    import fullscreenLayout from './layouts/fullscreen-layout.vue';

    export default {
        components: {
            app: appLayout,
            auth: authLayout,
            fullscreen: fullscreenLayout,
        },
    };
</script>